<template>
  <div class="grid grid-cols-12">
    <!-- left side -->
    <div class="col-span-12 lg:col-span-4 bg-maroon" style="">
      <div class="text-center">
        <img class="mx-auto" src="/img/icons/cp-trinity-logo.png" alt="" width="155" height="87">
        <div class="judson judson-400 text-xl text-[#EEBB77] md:text-[26px] mt-8">Registration Form for CP Meet</div>
        <div class="judson judson-700 text-[40px] leading-[52px] mt-12 text-[#E6E6E6] md:text-[50px]">Trinity Edition<br>by B|Safal</div>
        <div class="judson  judson-400 text-[#E6E6E6] mt-2.5 text-[23px] md:text[33px]">NCR</div>
        
        <svg class="mx-auto mt-7 max-w-full" width="370" height="1" viewBox="0 0 370 1" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.7" width="370" height="1" rx="0.5" fill="url(#paint0_linear_2027_61)"/>
<defs>
<linearGradient id="paint0_linear_2027_61" x1="0" y1="0.5" x2="370" y2="0.5" gradientUnits="userSpaceOnUse">
<stop stop-color="#318160"/>
<stop offset="0.5" stop-color="#8DCBB1"/>
<stop offset="1" stop-color="#318160"/>
</linearGradient>
</defs>
</svg>


        <div class="flex flex-row lg:flex-col gap-10 my-10">
          <div class="grow">
            <img class="mx-auto" src="/img/icons/calendor.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6"> 7th & 8th October 2026</div>
          </div>
          <div class="grow">
            <img class="mx-auto" src="/img/icons/time.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6">11 AM Onwards</div>
          </div>
          <div class="grow">
            <img class="mx-auto" src="/img/icons/location.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6">Crowne Plaza Gurgaon,<br>an IHG Hotel</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right side -->
    <div class="col-span-12 lg:col-span-8 px-4 md:px-16 py-16 md:py-24 min-h-[100vh] bg-pattern">
      <div class="max-w-[850px]">
        <div class="inter inter-600 text-[#FFFFFF] text-center lg:text-left text-lg leading-5 mb-8 md:text-[27px] md:leading-8">Register Now for the CP Meet</div>
        <form class="bg-white rounded-md p-6 md:p-8 shadow-md" @submit.prevent="submitFn()">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-7">
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="name">Full Name<sup>*</sup></label>
              <input required class="form-field" type="text" name="name" v-model.trim="cpParams.name" id="name" placeholder="Rahul Jain">
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="mobile">Mobile Number<sup>*</sup></label>
              <input required class="form-field" type="number" name="mobile" v-model.trim="cpParams.contact_number" id="mobile" placeholder="98765 43210">
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="email">Email<sup>*</sup></label>
              <input required class="form-field" type="email" name="email" v-model.trim="cpParams.email" id="email" placeholder="hello@example.com">
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]">No of Attendees<sup>*</sup></label>
              <ul class="grid grid-cols-2 radio-input">
                <li v-for="(atend, key) in options" :key="key">
                  <input
                    type="radio"
                    :id="'attendee-' + key"
                    :value="atend"
                    name="attendees"
                    class="sr-only peer"
                    required
                    v-model="cpParams.number_of_attendees"
                  />
                  <label
                    :for="'attendee-' + key"
                    class="inline-flex items-center justify-center w-full p-3 text-black text-opacity-30 bg-white border border-[#CCCCCC] cursor-pointer hover:text-[#318160] hover:border-[#318160] hover:bg-[#EEF8F0] peer-checked:text-[#318160] peer-checked:border-[#318160] peer-checked:bg-[#EEF8F0]">
                    {{ atend }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="cpFirmName">Channel Partner Firm Name<sup>*</sup></label>
              <input required class="form-field" type="text" name="cpFirmName" v-model.trim="cpParams.firm_name" id="cpFirmName" placeholder="Sky Enterprises">
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="location">Locality<sup>*</sup></label>
              <input required class="form-field" type="text" v-model.trim="cpParams.location" name="location" id="location" placeholder="Powai">
            </div>
            <div class="mb-6">
              <label class="block mb-2 text-black inter inter-400 text-[15px]" for="reraNo">Rera No</label>
              <input class="form-field" type="text" name="reraNo" v-model.trim="cpParams.rera_no" id="reraNo" placeholder="Rera No">
            </div>
          </div>
          <div class="text-center mt-2">
            <button type="submit" class="w-full md:w-auto rounded inter inter-600 text-[15px] text-white leading-[18px] py-4 px-16 mx-auto bg-[#318160] hover:bg-[#2a6f53] transition-colors">Submit</button>
            <div class="inter inter-400 text-xs text-black text-opacity-50 mt-4">By clicking the submit button, you accept our terms and conditions.</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      cpParams: {
        type: Object,
        required: true
      },
      submitFn: {
        type: Function,
        required: true
      },
    },
    data() {
      return {
        options: [1,2]
      }
    },
    }

  </script>

<style>

  .bg-maroon{
    background-image: url('~@/../public/img/icons/bg-pattern-g.png');
    background-size: cover;
    background-position: center;
  }

  .bg-pattern{
    background-color: #2B4A41;
    background-image: url('~@/../public/img/icons/Slide-bg.png');
    background-size: cover;
    background-position: right bottom;
    background-repeat: no-repeat;
  }
  .form-field{
    display: block;
    width: 100%;
    height: 52px;
    padding: 0 16px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    font-family: inherit;
    font-size: 15px;
    transition: all .2s;
  }
  .form-field::placeholder{
    color: rgba(0, 0, 0, 0.3);
  }
  .form-field:focus{
    border-color: #318160;
    box-shadow: 0 0 0 1px #318160;
    outline: none;
  }
  label sup{
    top: -0.3em;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  /* Firefox */
  input[type="number"] {
      -moz-appearance: textfield;
  }

  /* General (Optional) */
  input[type="number"] {
      appearance: textfield; /* Fallback for other browsers */
  }

</style>